module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"salary":"Salary","address":"Address","experience":"Experience","employment":"Type of employment","show":"View page"}}')
  delete Component.options._Ctor
}
